<script setup lang="ts">
import { useDarkMode, type ThemeMode } from '../composables/useDarkMode'

const { theme } = useDarkMode()

const options: { value: ThemeMode; label: string }[] = [
  { value: 'system', label: '跟随系统' },
  { value: 'light', label: '浅色' },
  { value: 'dark', label: '深色' },
  { value: 'eye-comfort', label: '护眼' },
  { value: 'geek', label: '极客' }
]
</script>

<template>
  <div class="flex items-center gap-sm">
    <span class="text-text-secondary text-sm">外观</span>
    <select
      :value="theme"
      @change="theme = ($event.target as HTMLSelectElement).value as ThemeMode"
      class="border border-border-subtle rounded-md px-sm py-xs bg-background-primary text-text-primary text-sm"
    >
      <option v-for="opt in options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
    </select>
  </div>
</template>
